<template>
  <div class="Index">
    <el-container>
      <el-aside width="200px">
        <ul v-for="(item,index) in this.$router.options.routes[4].children" :key="index">
          <li>
            <router-link
              :to="'/sample'+'/'+item.path"
              :key="index"
            >{{item.name.replace('Sample', '')}}</router-link>
          </li>
        </ul>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "Index",
  created() {
    this.init();
  },
  methods: {
    ...mapActions(["getsLocalDb"]),
    init() {
      let tables = this.$store.getters.tables;
      tables.forEach(table => {
        this.getsLocalDb(table);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.Sample {
  height: 100%;
}
.el-container {
  height: 100%;
}
.el-aside {
  background-color: $color-info;
  height: 100%;
}
.nav {
  margin-top: 30px;
  margin-left: 30px;
  text-align: center;
  font-weight: bold;
}
ul {
  list-style: none;
}
li a {
  text-decoration: none;
  color: white;
  font-weight: bold;
}
</style>